import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

import type { FetchRequestError } from "@lib/errors";

import type { BaseTableParams, InternalTableFetcherFunctionWithShadowError } from "../types";

/**
 * Strongly type a Data Table fetcher function with the error class it throws
 *
 * Since any server error is possible, this forces an intersection of the specified error type and FetchRequestError
 */
export const createTableFetcherFunctionWithShadowError =
  <Error extends FetchRequestError>() =>
  <Args extends BaseTableParams, Result extends BaseTableResultItem, FullResult extends TableResult<Result>>(
    fetcher: InternalTableFetcherFunctionWithShadowError<Error, Args, Result, FullResult>
  ) =>
    fetcher;
